module.exports = __webpack_public_path__ + "img/christmas-island.18a45791.svg";